/**
 * A Stimulus controller that fetches a Turbo Stream response when an input field loses focus.
 * @module TurboOnBlurController
 *
 * @example
 *  HTML that uses the TurboOnBlurController to fetch a Turbo Stream response:
 *  <input type="text" data-controller="turbo-on-blur" data-action="blur->turbo-on-blur#handleBlur" data-turbo-on-blur-target="inputField" data-turbo-on-blur-url-value="https://your-turbo-stream-endpoint" data-turbo-on-blur-params-value="[{param_name: 'q', param_value: 'test'}]">
 *  The value of the input field will always be sent as a param on the url as "value". Additional params can be included by adding them to the data-turbo-on-blur-params-value attribute following the format above.
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['inputField'];

  static values = {
    url: String,
    params: Array
  }

  handleBlur(event) {
    const value = event.target.value;
    const url = new URL(this.urlValue, window.location.origin);

    url.searchParams.set('value', value);
    this.paramsValue.forEach((param) => {
      url.searchParams.set(param.param_name, param.param_value);
    });

    fetch(url, {
      headers: { accept: 'text/vnd.turbo-stream.html' }
    })
      .then((response) => response.text())
      .then((html) => {
        Turbo.renderStreamMessage(html);
      });
  }
}
